import React, { useState, useEffect } from 'react';
import './TermsModal.css';

export const TermsModal = ({ isOpen, onAgree, onClose }) => {
    const [agreed, setAgreed] = useState(false);

    // Reset checkbox whenever modal opens
    useEffect(() => {
        if (isOpen) setAgreed(false);
    }, [isOpen]);

    // Close on Escape key
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="terms-modal-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="terms-modal-title"
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className="terms-modal-panel">
                {/* Drag handle (visual cue for bottom sheet) */}
                <div className="terms-modal-handle" aria-hidden="true" />

                {/* Header */}
                <div className="terms-modal-header">
                    <span className="terms-modal-icon">📋</span>
                    <h2 className="terms-modal-title" id="terms-modal-title">
                        Before you continue…
                    </h2>
                </div>

                <p className="terms-modal-body">
                    We'd love to have you on board! Just a quick read before we unlock your full brain profile. 🧠✨
                </p>

                {/* Scrollable T&C excerpt */}
                <div className="terms-scroll-box" role="region" aria-label="Terms and Conditions">
                    <h4>Terms of Service</h4>
                    <p>
                        By creating an account, you agree to use You Don't Know You for personal, non-commercial purposes only.
                        You must be at least 13 years old to use this service. You are responsible for maintaining
                        the confidentiality of your account credentials.
                    </p>
                    <h4>Data & Privacy</h4>
                    <p>
                        We collect the data you provide (handwriting images, quiz responses) solely to generate your
                        personalised brain profile. We do not sell your personal data to third parties. Your data is
                        stored securely and you may request deletion at any time by contacting us.
                    </p>
                    <h4>Content</h4>
                    <p>
                        Your brain profile and character card are generated by AI and are for entertainment and
                        self-discovery purposes only. They do not constitute professional psychological or medical advice.
                    </p>
                    <h4>Changes</h4>
                    <p>
                        We may update these terms from time to time. Continued use of the service after changes
                        constitutes acceptance of the updated terms. We'll notify you of significant changes via email.
                    </p>
                </div>

                {/* Checkbox */}
                <label className="terms-checkbox-row" htmlFor="terms-agree-checkbox">
                    <input
                        id="terms-agree-checkbox"
                        type="checkbox"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                    />
                    <span className={`terms-custom-checkbox ${agreed ? 'checked' : ''}`} aria-hidden="true">
                        <span className="terms-checkmark">✓</span>
                    </span>
                    <span className="terms-checkbox-label">
                        I have read and agree to the{' '}
                        <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                            Terms of Service
                        </a>{' '}
                        and{' '}
                        <a href="/privacy" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                            Privacy Policy
                        </a>
                        .
                    </span>
                </label>

                {/* Actions */}
                <div className="terms-modal-actions">
                    <button
                        className="terms-cancel-btn"
                        onClick={onClose}
                        aria-label="Cancel and go back"
                    >
                        Cancel
                    </button>
                    <button
                        className="terms-agree-btn"
                        onClick={onAgree}
                        disabled={!agreed}
                        aria-disabled={!agreed}
                    >
                        Agree & Sign Up →
                    </button>
                </div>
            </div>
        </div>
    );
};
